<template>
  <div class="grid grid-flow-row gap-4 lg:px-8">
    <div class="flex justify-center min-height-auto">
      <h1
        class="text-3xl text-center font-bold leading-none tracking-tight text-gray-900 md:text-3xl lg:text-3xl"
      >
        Ventas
      </h1>
    </div>

    <span>
      <svg
        class="w-5 h-5 inline-block text-gray-800"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-width="2"
          d="M18.796 4H5.204a1 1 0 0 0-.753 1.659l5.302 6.058a1 1 0 0 1 .247.659v4.874a.5.5 0 0 0 .2.4l3 2.25a.5.5 0 0 0 .8-.4v-7.124a1 1 0 0 1 .247-.659l5.302-6.059c.566-.646.106-1.658-.753-1.658Z"
        />
      </svg>
      Filtro por fecha:
    </span>

    <!-- Filtros -->
    <div class="grid grid-cols-1 lg:grid-cols-5 gap-4">
      <div>
        <input
          type="date"
          v-model="startDate"
          @change="filterLavados"
          class="form-control block px-3 py-2 border border-gray-300 rounded-md text-gray-700 bg-white appearance-none cursor-pointer focus:outline-none focus:ring-1 focus:ring-blue-500 w-full"
        />
      </div>
      <div>
        <input
          type="date"
          v-model="endDate"
          @change="filterLavados"
          class="form-control block px-3 py-2 border border-gray-300 rounded-md text-gray-700 bg-white appearance-none cursor-pointer focus:outline-none focus:ring-1 focus:ring-blue-500 w-full"
        />
      </div>
      <div>
        <router-link :to="{ path: '/formlavado', query: { isAdmin: true } }">
          <button
            type="button"
            class="focus:outline-none text-white bg-[#3edfa9] hover:bg-[#ffe068] focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-2 md:px-5 py-2.5 w-full"
          >
            <svg
              class="w-6 h-6 inline-block text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 7.757v8.486M7.757 12h8.486M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            Agregar Venta
          </button>
        </router-link>
      </div>
      <div>
        <button
          type="button"
          @click="fetchLavados"
          class="focus:outline-none text-white bg-[#3edfa9] hover:bg-[#ffe068] focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-2 md:px-5 py-2.5 w-full"
        >
          <svg
            class="w-6 h-6 inline-block text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M17.651 7.65a7.131 7.131 0 0 0-12.68 3.15M18.001 4v4h-4m-7.652 8.35a7.13 7.13 0 0 0 12.68-3.15M6 20v-4h4"
            />
          </svg>
          Actualizar
        </button>
      </div>
      <div>
        <button
          type="button"
          @click="exportToExcel"
          class="text-white bg-[#3edfa9] hover:bg-[#ffe068] font-medium rounded-lg text-sm px-2 md:px-5 py-2.5 w-full"
        >
          <svg
            class="w-6 h-6 inline-block text-white"
            fill="#fff"
            viewBox="0 0 36 36"
            version="1.1"
            preserveAspectRatio="xMidYMid meet"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>export-line</title>
            <path
              d="M6,13.61h7.61V6H24v8.38h2V6a2,2,0,0,0-2-2H10.87L4,10.87V30a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2H6Zm0-1.92L11.69,6H12v6H6Z"
            />
            <path
              d="M28.32,16.35a1,1,0,0,0-1.41,1.41L30.16,21H18a1,1,0,0,0,0,2H30.19l-3.28,3.28a1,1,0,1,0,1.41,1.41L34,22Z"
            />
            <rect x="0" y="0" width="36" height="36" fill-opacity="0"></rect>
          </svg>
          Exportar a Excel
        </button>
      </div>
    </div>

    <!-- Resumen -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div
        class="bg-green-100 text-green-800 text-md font-medium me-2 px-3.5 py-2 rounded"
      >
        <svg
          class="w-6 h-6 inline-block text-gray-800"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M10 3v4a1 1 0 0 1-1 1H5m8-2h3m-3 3h3m-4 3v6m4-3H8M19 4v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1ZM8 12v6h8v-6H8Z"
          />
        </svg>
        Registros: {{ filteredLavados.length }}
      </div>

      <div
        class="bg-green-100 text-green-800 text-md font-medium me-2 px-3.5 py-2 rounded"
      >
        <svg
          class="w-6 h-6 inline-block text-gray-800"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M8 17.345a4.76 4.76 0 0 0 2.558 1.618c2.274.589 4.512-.446 4.999-2.31.487-1.866-1.273-3.9-3.546-4.49-2.273-.59-4.034-2.623-3.547-4.488.486-1.865 2.724-2.899 4.998-2.31.982.236 1.87.793 2.538 1.592m-3.879 12.171V21m0-18v2.2"
          />
        </svg>
        Facturados: {{ formatImporte(calculateTotalImporte()) }}
      </div>

      <div class="flex justify-start min-height-auto">
        <form>
          <select
            v-model="results"
            name="results"
            id="results"
            @change="updateResults"
            class="bg-gray-50 border border-[#3edfa9] text-gray-900 text-sm rounded-lg focus:ring-[#3edfa9] focus:border-[#3edfa9] block w-full p-2.5"
          >
            <option selected value="10">Mostrar resultados</option>
            <option value="20">Mostrando 20 resultados</option>
            <option value="30">Mostrando 30 resultados</option>
            <option value="50">Mostrando 50 resultados</option>
          </select>
        </form>
      </div>
    </div>

    <hr class="divide-y divide-gray-100" />

    <!-- Tabla -->
    <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
      <table
        v-if="filteredLavados.length > 0"
        class="w-full text-sm text-left rtl:text-right text-gray-500"
      >
        <thead class="text-xs text-gray-700 uppercase bg-[#96ffdf]">
          <tr>
            <th scope="col" class="px-4 py-3">Fecha</th>
            <th scope="col" class="px-4 py-3">Presupuesto</th>
            <th scope="col" class="px-4 py-3">Cliente</th>
            <th scope="col" class="px-4 py-3">Descripción</th>
            <th scope="col" class="px-4 py-3">Servicio</th>
            <th scope="col" class="px-4 py-3">Metodo de Pago</th>
            <th scope="col" class="px-4 py-3">Importe</th>
            <th scope="col" class="px-4 py-3">Accion</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="bg-white border-b"
            v-for="(lavado, index) in filteredLavados"
            v-show="(pag - 1) * results <= index && pag * results > index"
            :key="lavado.id"
          >
            <th
              scope="row"
              class="px-4 py-4 font-medium text-gray-900 whitespace-nowrap"
            >
              {{ formatDate(lavado.fecha) }}
            </th>
            <td class="px-4 py-4">
              {{ getNumeroPresupuesto(lavado.presupuestoId) || "N/A" }}
            </td>
            <td class="px-4 py-4">
              {{
                lavado.cliente
                  ? lavado.cliente.nombreApellido
                  : lavado.clienteId || "N/A"
              }}
            </td>
            <td class="px-4 py-4">{{ lavado.descripcion }}</td>
            <td class="px-4 py-4">
              {{ lavado.servicio ? lavado.servicio.nombre : "Sin Servicio" }}
            </td>
            <td class="px-4 py-4">{{ lavado.metodoPago }}</td>
            <td class="px-4 py-4">{{ formatImporte(lavado.importe) }}</td>
            <td
              class="grid lg:flex md:flex px-2 md:px-2 py-4 lg:text-left md:text-center"
            >
              <a
                href="#"
                @click="editLavado(lavado)"
                class="font-regular text-xs text-gray-800 hover:underline"
              >
                <svg
                  class="w-4 h-4 inline-block text-gray-800"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"
                  />
                </svg>
                Editar
              </a>
              <a
                href="#"
                @click="deleteModal(lavado.id)"
                class="font-medium text-xs text-red-500 hover:underline lg:ml-2"
              >
                <svg
                  class="w-4 h-4 inline-block text-gray-800"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke="#ef4444"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"
                  />
                </svg>
                Eliminar
              </a>
              <a
                href="#"
                @click="generatePdf(lavado.id)"
                class="font-medium text-xs text-gray-800 hover:underline lg:ml-2"
              >
                <svg
                  class="w-4 h-4 inline-block text-gray-800"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M5.625 15C5.625 14.5858 5.28921 14.25 4.875 14.25C4.46079 14.25 4.125 14.5858 4.125 15H5.625ZM4.875 16H4.125H4.875ZM19.275 15C19.275 14.5858 18.9392 14.25 18.525 14.25C18.1108 14.25 17.775 14.5858 17.775 15H19.275ZM11.1086 15.5387C10.8539 15.8653 10.9121 16.3366 11.2387 16.5914C11.5653 16.8461 12.0366 16.7879 12.2914 16.4613L11.1086 15.5387ZM16.1914 11.4613C16.4461 11.1347 16.3879 10.6634 16.0613 10.4086C15.7347 10.1539 15.2634 10.2121 15.0086 10.5387L16.1914 11.4613ZM11.1086 16.4613C11.3634 16.7879 11.8347 16.8461 12.1613 16.5914C12.4879 16.3366 12.5461 15.8653 12.2914 15.5387L11.1086 16.4613ZM8.39138 10.5387C8.13662 10.2121 7.66533 10.1539 7.33873 10.4086C7.01212 10.6634 6.95387 11.1347 7.20862 11.4613L8.39138 10.5387ZM10.95 16C10.95 16.4142 11.2858 16.75 11.7 16.75C12.1142 16.75 12.45 16.4142 12.45 16H10.95ZM12.45 5C12.45 4.58579 12.1142 4.25 11.7 4.25C11.2858 4.25 10.95 4.58579 10.95 5H12.45ZM4.125 15V16H5.625V15H4.125ZM4.125 16C4.125 18.0531 5.75257 19.75 7.8 19.75V18.25C6.61657 18.25 5.625 17.2607 5.625 16H4.125ZM7.8 19.75H15.6V18.25H7.8V19.75ZM15.6 19.75C17.6474 19.75 19.275 18.0531 19.275 16H17.775C17.775 17.2607 16.7834 18.25 15.6 18.25V19.75ZM19.275 16V15H17.775V16H19.275ZM12.2914 16.4613L16.1914 11.4613L15.0086 10.5387L11.1086 15.5387L12.2914 16.4613ZM12.2914 15.5387L8.39138 10.5387L7.20862 11.4613L11.1086 16.4613L12.2914 15.5387ZM12.45 16V5H10.95V16H12.45Z"
                    fill="#000000"
                  />
                </svg>
                Detalle
              </a>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-else>
        <ul class="max-w-lg space-y-2 list-inside">
          <li class="flex items-center text-red-500 font-semibold">
            <svg
              class="w-5 h-5 mr-2 text-red-800"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m15 9-6 6m0-6 6 6m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            No se encontraron datos para el rango de fechas seleccionado.
          </li>
        </ul>
      </div>
    </div>

    <!-- Paginación -->
    <div class="flex justify-end items-center mt-4">
      <span class="mx-2">
        Mostrando {{ (pag - 1) * results + 1 }} -
        {{
          pag * results > filteredLavados.length
            ? filteredLavados.length
            : pag * results
        }}
        de {{ filteredLavados.length }} resultados
      </span>
      <button
        class="bg-[#3edfa9] hover:bg-gray-400 text-white font-regular mr-3 py-1 px-4 rounded shadow"
        @click="pag = pag - 1"
        :disabled="pag === 1"
      >
        Anterior
      </button>
      <button
        class="bg-[#3edfa9] hover:bg-gray-400 text-white font-regular py-1 px-4 rounded shadow"
        @click="pag = pag + 1"
        :disabled="pag === totalPages"
      >
        Siguiente
      </button>
    </div>
  </div>

  <Modal message="Registro" @confirm="deleteLavado" ref="modalComponent" />
</template>

<script>
import lavadoService from "../../composables/api/lavadoService.js";
import presupuestoService from "../../composables/api/presupuestoService.js";
import authService from "../../composables/api/authService.js";
import tenantService from "../../composables/api/tenantService.js";
import { API_URL } from "../../config.js";
import { ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import Toast from "../Toast/Toast.vue";
import Modal from "../modalConfirmar/ModalConfirmar.vue";
import { jsPDF } from "jspdf";
import * as XLSX from "xlsx";

export default {
  components: { Toast, Modal },
  name: "lavados",
  data() {
    return { results: 10, pag: 1 };
  },
  setup() {
    const lavados = ref([]);
    const presupuestos = ref([]);
    const startDate = ref("");
    const endDate = ref("");
    const showMessage = ref(false);
    const router = useRouter();
    const toastComponent = ref(null);
    const modalComponent = ref(null);
    const modal = ref();
    const results = ref(10);

    // Usuario + Tenant
    const currentUser = ref(null);
    const tenantInfo = ref(null);
    const error = ref("");

    const loadUsuarioYTenant = async () => {
      try {
        const user = await authService.getCurrentUser();
        currentUser.value = user || null;
        if (user?.tenantId != null) {
          const t = await tenantService.getTenantByTenantId(user.tenantId);
          tenantInfo.value = t || null;
        } else {
          tenantInfo.value = null;
        }
      } catch (e) {
        error.value = "Error al cargar usuario/tenant";
        console.error(e);
      }
    };

    // ---------- Helpers generales ----------
    const getNumeroPresupuesto = (presupuestoId) => {
      if (!presupuestos.value.length) return presupuestoId;
      const presupuesto = presupuestos.value.find(
        (p) => p.id === presupuestoId
      );
      return presupuesto ? presupuesto.codigo || presupuestoId : presupuestoId;
    };

    const exportToExcel = () => {
      const wb = XLSX.utils.book_new();
      const dataToExport = filteredLavados.value.map((lavado) => ({
        Fecha: formatDate(lavado.fecha),
        Presupuesto: getNumeroPresupuesto(lavado.presupuestoId),
        Cliente: lavado.cliente ? lavado.cliente.nombreApellido : "Sin cliente",
        Descripción: lavado.descripcion,
        Servicio: lavado.servicio ? lavado.servicio.nombre : "Sin Servicio",
        MetodoDePago: lavado.metodoPago,
        Importe: lavado.importe,
      }));
      const ws = XLSX.utils.json_to_sheet(dataToExport);
      XLSX.utils.book_append_sheet(wb, ws, "Lavados");
      XLSX.writeFile(wb, "ventas.xlsx");
    };

    const ARS = (n) =>
      Number(n ?? 0).toLocaleString("es-AR", {
        style: "currency",
        currency: "ARS",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

    // Carga imagen remota como DataURL y devuelve tamaño natural (para mantener proporción)
    const loadImageInfo = async (url) => {
      try {
        if (!url || !String(url).trim()) return null;
        const res = await fetch(url, { mode: "cors" });
        if (!res.ok) return null;
        const blob = await res.blob();
        const toDataURL = (b) =>
          new Promise((resolve, reject) => {
            const fr = new FileReader();
            fr.onload = () => resolve(fr.result);
            fr.onerror = reject;
            fr.readAsDataURL(b);
          });
        const dataUrl = await toDataURL(blob);

        const dims = await new Promise((resolve) => {
          const img = new Image();
          img.onload = () =>
            resolve({
              w: img.naturalWidth || img.width,
              h: img.naturalHeight || img.height,
            });
          img.onerror = () => resolve({ w: 0, h: 0 });
          img.src = dataUrl;
        });

        return { dataUrl, ...dims };
      } catch {
        return null;
      }
    };

    const imageFormatFromDataUrl = (dataUrl) =>
      dataUrl?.startsWith("data:image/png") ? "PNG" : "JPEG";

    const drawTextBlock = (doc, text, x, y, maxWidth, lineHeight = 5) => {
      if (!text) return y;
      const lines = doc.splitTextToSize(String(text), maxWidth);
      lines.forEach((line, i) => doc.text(line, x, y + i * lineHeight));
      return y + lines.length * lineHeight;
    };

    // Convierte la parte entera de un número a palabras en ES (hasta millones)

    const numeroAPalabrasES = (n) => {
      n = Math.floor(Math.abs(Number(n) || 0));
      if (n === 0) return "PESOS CERO";
      const u = [
        "",
        "UNO",
        "DOS",
        "TRES",
        "CUATRO",
        "CINCO",
        "SEIS",
        "SIETE",
        "OCHO",
        "NUEVE",
      ];
      const e = [
        "DIEZ",
        "ONCE",
        "DOCE",
        "TRECE",
        "CATORCE",
        "QUINCE",
        "DIECISÉIS",
        "DIECISIETE",
        "DIECIOCHO",
        "DIECINUEVE",
      ];
      const d = [
        "",
        "DIEZ",
        "VEINTE",
        "TREINTA",
        "CUARENTA",
        "CINCUENTA",
        "SESENTA",
        "SETENTA",
        "OCHENTA",
        "NOVENTA",
      ];
      const c = [
        "",
        "CIENTO",
        "DOSCIENTOS",
        "TRESCIENTOS",
        "CUATROCIENTOS",
        "QUINIENTOS",
        "SEISCIENTOS",
        "SETECIENTOS",
        "OCHOCIENTOS",
        "NOVECIENTOS",
      ];

      const decenas = (num) => {
        if (num < 10) return u[num];
        if (num < 20) return e[num - 10];
        if (num < 30)
          return num === 20 ? "VEINTE" : "VEINTI" + u[num - 20].toLowerCase();
        const t = Math.floor(num / 10),
          r = num % 10;
        return r ? `${d[t]} Y ${u[r]}` : d[t];
      };
      const centenas = (num) => {
        if (num === 100) return "CIEN";
        const t = Math.floor(num / 100),
          r = num % 100;
        return [c[t], decenas(r)].filter(Boolean).join(" ").trim();
      };
      const seccion = (num, divisor, singular, plural) => {
        const cant = Math.floor(num / divisor);
        const resto = num - cant * divisor;
        const texto =
          cant === 0
            ? ""
            : cant === 1
            ? `${singular}`
            : `${numeroAPalabrasES(cant).replace(/^PESOS\s+/, "")} ${plural}`;
        return { texto, resto };
      };

      let palabras = [];
      let tmp = n;

      const { texto: millones, resto: rMill } = seccion(
        tmp,
        1_000_000,
        "UN MILLÓN",
        "MILLONES"
      );
      if (millones) palabras.push(millones);
      tmp = rMill;

      const { texto: miles, resto: rMil } = seccion(tmp, 1000, "MIL", "MIL");
      if (miles) palabras.push(miles);
      tmp = rMil;

      if (tmp > 0) {
        palabras.push(tmp < 100 ? decenas(tmp) : centenas(tmp));
      }

      return (
        "PESOS " + palabras.join(" ").replace(/\s+/g, " ").trim()
      ).toUpperCase();
    };

    const PDF_STYLE = {
      LOGO_MAX_W: 48, // mm (máximo ancho del logo)
      LOGO_MAX_H: 14, // mm (máximo alto del logo)
      LOGO_MIN_W: 18, // mm
      LOGO_MIN_H: 8, // mm
      HEADER_GAP: 3, // espacio debajo del logo/nombre
      LOGO_INSET_X: -4, // empuja 4mm hacia la izquierda (dentro del borde)
      LOGO_INSET_Y: -2,
      BOX_W: 190, // ancho de la caja
      BOX_H: 140, // alto de la caja
      BOX_RADIUS: 2, // borde redondeado
      BOX_LINE_WIDTH: 0.35,
      BOX_LINE_COLOR: "#9ca3af",
      BOX_PADDING: 6, // padding interno
      PAGE_MARGIN_X: 10,
      PAGE_MARGIN_Y: 10,
      BOX_GAP_Y: 5, // separación entre ORIGINAL y DUPLICADO
    }; // === PDF con logo del perfil (si existe) y reglas de abono/contado + plazas ===
    const generatePdf = async (selectedLavadoId) => {
      if (!tenantInfo.value) await loadUsuarioYTenant();

      const doc = new jsPDF();
      const venta =
        filteredLavados.value.find((x) => x.id === selectedLavadoId) || {}; // ------- Datos básicos -------

      const fechaTexto = venta?.fecha
        ? formatDate(venta.fecha)
        : new Date().toLocaleDateString("es-AR");
      const clienteNombre = venta?.cliente?.nombreApellido || "—";
      const clienteDoc = venta?.cliente?.dni || "";
      const clienteIVA = "Consumidor Final";
      const descripcion = venta?.descripcion || "—";
      const metodoPago = venta?.metodoPago || "—";
      const presupuesto = venta?.presupuestoId
        ? getNumeroPresupuesto(venta.presupuestoId)
        : "—";
      const servicioTxt = venta?.servicio?.nombre || ""; // ------- Plazas (nombre real BDD) -------

      const plazasCompradas = Number(
        venta?.cantidadOcupada ??
          venta?.plazas ??
          venta?.servicio?.cantidadOcupada ??
          0
      ); // ------- Monto (ABONO vs CONTADO) -------

      const totalVenta = Number(venta?.importe ?? 0);
      const abonadoDirecto = Number(venta?.importeAbonado ?? 0);
      const deuda = isFinite(Number(venta?.deuda)) ? Number(venta.deuda) : null; // Si no vino importeAbonado pero hay deuda, deducimos el pago: pago = total - deuda

      const abonadoDeducido =
        abonadoDirecto <= 0 && deuda !== null
          ? Math.max(totalVenta - deuda, 0)
          : 0;

      const totalAbonado =
        abonadoDirecto > 0 ? abonadoDirecto : abonadoDeducido;

      const isAbono = totalAbonado > 0 && totalAbonado < totalVenta;
      const montoRecibo = isAbono ? totalAbonado : totalVenta;
      const saldo = Math.max(totalVenta - totalAbonado, 0);

      const ARS = (n) =>
        Number(n ?? 0).toLocaleString("es-AR", {
          style: "currency",
          currency: "ARS",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

      const importeTxt = ARS(montoRecibo);
      const importeWords = numeroAPalabrasES(montoRecibo);
      const totalTxt = ARS(totalVenta);
      const abonadoTxt = ARS(totalAbonado);
      const saldoTxt = ARS(saldo); // ------- Perfil (tenant) -------

      const t = tenantInfo.value || {};
      const empresa = {
        nombre: (t.nombreEmpresa || t.name || "").toString().trim() || "—",
        legajo: t.legajo || "",
        domicilio: t.direccionFiscal || "",
        localidad: t.localidad || "",
        telefono: t.telefono || "",
        web: t.web || "",
        email: t.email || "",
        cuit: t.cuit || "",
        iibb: t.numeroIIBB || "",
        iva: t.condicionIVA || "",
        inicioActividades: t.inicioActividades || "",
        bannerUrl: (t.bannerUrl || "").toString().trim(),
      };

      const puntoYNumero = `0001-${String(selectedLavadoId ?? 1).padStart(
        8,
        "0"
      )}`; // Se ha modificado esta parte para eliminar "ABONO" y "CONTADO"
      const comp = {
        tipo: `Recibo Oficial`,
        puntoYNumero,
        fileNro: String(selectedLavadoId ?? 1),
      }; // ------- Logo -------

      const logoInfo = empresa.bannerUrl
        ? await loadImageInfo(empresa.bannerUrl)
        : null; // Se ha modificado esta función para eliminar el texto extra y el espacio

      const drawHeader = (x, y, w) => {
        let headerBottomY;
        if (logoInfo?.dataUrl && logoInfo.w > 0 && logoInfo.h > 0) {
          const maxW = PDF_STYLE.LOGO_MAX_W;
          const maxH = PDF_STYLE.LOGO_MAX_H;
          const ratio = Math.min(maxW / logoInfo.w, maxH / logoInfo.h);
          const imgW = Math.max(
            PDF_STYLE.LOGO_MIN_W,
            Math.min(maxW, logoInfo.w * ratio)
          );
          const imgH = Math.max(
            PDF_STYLE.LOGO_MIN_H,
            Math.min(maxH, logoInfo.h * ratio)
          );

          const logoX = x + (PDF_STYLE.LOGO_INSET_X || 0);
          const logoY = y + (PDF_STYLE.LOGO_INSET_Y || 0);

          doc.addImage(
            logoInfo.dataUrl,
            imageFormatFromDataUrl(logoInfo.dataUrl),
            logoX,
            logoY,
            imgW,
            imgH
          );
          headerBottomY = logoY + imgH + PDF_STYLE.HEADER_GAP;
        } else {
          doc.setFont("helvetica", "bold");
          doc.setFontSize(14);
          doc.text(empresa.nombre, x, y + 10);
          headerBottomY = y + 14;
        } // columnas

        const leftX = x,
          rightX = x + w;
        let leftY = headerBottomY;
        let rightY = headerBottomY;

        doc.setFont("helvetica", "normal");
        doc.setFontSize(8);

        if (empresa.legajo)
          leftY = drawTextBlock(
            doc,
            `Legajo: ${empresa.legajo}`,
            leftX,
            leftY,
            w * 0.6
          );
        if (empresa.domicilio)
          leftY = drawTextBlock(
            doc,
            empresa.domicilio,
            leftX,
            leftY + 1,
            w * 0.6
          );
        const locTel = [empresa.localidad, empresa.telefono]
          .filter(Boolean)
          .join(" • ");
        if (locTel)
          leftY = drawTextBlock(doc, locTel, leftX, leftY + 1, w * 0.6);
        const webMail = [empresa.web, empresa.email].filter(Boolean).join("  ");
        if (webMail)
          leftY = drawTextBlock(doc, webMail, leftX, leftY + 1, w * 0.6);

        doc.setFont("helvetica", "bold");
        doc.setFontSize(11);
        doc.text(`${comp.tipo} ${comp.puntoYNumero}`, rightX, rightY, {
          align: "right",
        });
        rightY += 6;

        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);
        doc.text(`Fecha: ${fechaTexto}`, rightX, rightY, { align: "right" });
        rightY += 5;
        if (empresa.iibb) {
          doc.text(`Nro.IIBB: ${empresa.iibb}`, rightX, rightY, {
            align: "right",
          });
          rightY += 5;
        }
        if (empresa.inicioActividades) {
          doc.text(
            `Inicio Act.: ${empresa.inicioActividades}`,
            rightX,
            rightY,
            { align: "right" }
          );
          rightY += 5;
        }
        if (empresa.cuit) {
          doc.text(`CUIT : ${empresa.cuit}`, rightX, rightY, {
            align: "right",
          });
          rightY += 5;
        }
        if (empresa.iva) {
          doc.text(empresa.iva, rightX, rightY, { align: "right" });
          rightY += 5;
        }

        return Math.max(leftY, rightY) + 9;
      };

      const drawCliente = (x, y, w) => {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        let nextY = drawTextBlock(doc, clienteNombre, x, y, w);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);
        const linea = [clienteDoc || "—", clienteIVA].filter(Boolean).join(" ");
        doc.text(linea, x, nextY + 5);
        nextY += 10;

        if (servicioTxt) {
          doc.text(`Servicio: ${servicioTxt}`, x, nextY);
          nextY += 5;
        }
        if (plazasCompradas > 0) {
          doc.text(`Plazas: ${plazasCompradas}`, x, nextY);
          nextY += 5;
        } // doc.text(`Modalidad: ${isAbono ? "ABONO" : "CONTADO"}`, x, nextY); // nextY += 5;

        return nextY;
      }; // Se ha modificado esta función para eliminar el detalle de abono, total y saldo.

      const drawCuerpo = (x, y, w) => {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(9);
        doc.text("Son", x, y);
        doc.setFont("helvetica", "normal");
        doc.text(importeWords, x + 12, y);

        doc.setFont("helvetica", "bold");
        doc.text("Documentos Asociados", x, y + 8);
        doc.setFont("helvetica", "normal");
        doc.text(String(presupuesto), x, y + 13);

        doc.setFont("helvetica", "bold");
        doc.text("Formas de Pago", x, y + 21);
        doc.setFont("helvetica", "normal");
        drawTextBlock(doc, metodoPago, x, y + 26, w);

        doc.setFont("helvetica", "bold");
        const afterDesc = drawTextBlock(doc, descripcion, x, y + 36, w);
      };

      const drawTotales = (x, y, w) => {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);
        doc.text(importeTxt.replace("ARS", "").trim(), x + w, y, {
          align: "right",
        });
      };

      const drawFooter = (x, y, w, etiquetaCopia) => {
        doc.setFont("helvetica", "normal");
        doc.setFontSize(8);
        doc.text(etiquetaCopia, x + w / 2, y, { align: "center" });
        doc.text(`File Nro.: ${comp.fileNro}`, x + w, y, { align: "right" });
      };

      const drawRecibo = (x, y, etiquetaCopia) => {
        const w = PDF_STYLE.BOX_W;
        const h = PDF_STYLE.BOX_H;

        doc.setLineWidth(PDF_STYLE.BOX_LINE_WIDTH);
        doc.setDrawColor(PDF_STYLE.BOX_LINE_COLOR);
        doc.roundedRect(
          x,
          y,
          w,
          h,
          PDF_STYLE.BOX_RADIUS,
          PDF_STYLE.BOX_RADIUS,
          "S"
        );

        const mx = x + PDF_STYLE.BOX_PADDING;
        const my = y + PDF_STYLE.BOX_PADDING;
        const iw = w - PDF_STYLE.BOX_PADDING * 2;

        const y0 = drawHeader(mx, my, iw);
        const y1 = drawCliente(mx, y0 + 2, iw);
        drawCuerpo(mx, y1 + 2, iw);

        drawTotales(mx, y + h - 14, iw);
        drawFooter(mx, y + h - 6, iw, etiquetaCopia);
      };

      const startX = PDF_STYLE.PAGE_MARGIN_X;
      const startY = PDF_STYLE.PAGE_MARGIN_Y;

      drawRecibo(startX, startY, "ORIGINAL");
      drawRecibo(
        startX,
        startY + PDF_STYLE.BOX_H + PDF_STYLE.BOX_GAP_Y,
        "DUPLICADO"
      );

      const pdfBlob = doc.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const win = window.open(
        pdfUrl,
        "_blank",
        "toolbar=yes,scrollbars=yes,resizable=yes"
      );
      if (win) win.addEventListener("load", () => win.resizeTo(1080, 800));
    };

    // ---------- Data ----------
    const fetchPresupuestos = async () => {
      try {
        const response = await presupuestoService.getAllPresupuestos();
        presupuestos.value = response || [];
      } catch (error) {
        console.error("Error al obtener presupuestos:", error);
      }
    };

    const fetchLavados = async () => {
      try {
        await fetchPresupuestos();
        const response = await lavadoService.getLavados();
        lavados.value = (response || []).sort(
          (a, b) => new Date(b.fecha) - new Date(a.fecha)
        );
        showMessage.value = true;
        setTimeout(() => (showMessage.value = false), 2000);
      } catch (error) {
        console.error(error);
      }
    };

    const formatDate = (date) =>
      new Date(date).toLocaleString("es-AR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });

    const filterLavados = () => {};

    const filteredLavados = computed(() => {
      if (startDate.value || endDate.value) {
        return lavados.value.filter((lavado) => {
          const lavadoDate = new Date(lavado.fecha);
          const start = startDate.value ? new Date(startDate.value) : null;
          const end = endDate.value ? new Date(endDate.value) : null;
          if (end) end.setDate(end.getDate() + 1);
          return (!start || lavadoDate >= start) && (!end || lavadoDate <= end);
        });
      }
      return lavados.value;
    });

    const calculateTotalImporte = () =>
      filteredLavados.value.reduce(
        (total, lavado) => total + (lavado.importe || 0),
        0
      );

    const editLavado = (lavado) => {
      router.push({
        path: "/formlavado",
        query: { isAdmin: true, id: lavado.id },
      });
    };

    const deleteLavado = async (lavadoId) => {
      try {
        await lavadoService.deleteLavado(lavadoId);
        fetchLavados();
      } catch (error) {
        console.error(error);
      }
    };

    const deleteModal = async (lavadoId) => {
      modal.value = await modalComponent.value.getModal(lavadoId);
    };

    const formatImporte = (importe) =>
      Number(importe || 0).toLocaleString("es-AR", {
        style: "currency",
        currency: "ARS",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

    onMounted(async () => {
      await loadUsuarioYTenant(); // ← carga perfil/tenant
      await fetchLavados();
      filterLavados();
    });

    return {
      lavados,
      startDate,
      endDate,
      showMessage,
      results,
      pag: ref(1),

      currentUser,
      tenantInfo,
      error,

      router,
      toastComponent,
      modalComponent,
      modal,

      filteredLavados,
      formatDate,
      filterLavados,
      calculateTotalImporte,
      fetchLavados,
      deleteLavado,
      editLavado,
      deleteModal,
      generatePdf,
      exportToExcel,
      getNumeroPresupuesto,
      formatImporte,
    };
  },
};
</script>

<style>
.viewport {
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 100%;
}
.table-container {
  max-width: 100%;
  overflow-x: auto;
}
table {
  min-width: 100%;
}
</style>
